import axios from "axios";
import { authHeader } from "../_helper/auth-header";



// const rootUrl = 'https://tq5qlx5s-7118.inc1.devtunnels.ms/api/v1/'
// const rootUrl = 'http://192.168.1.102:7118/api/v1/'
// export const frontEndURL = 'http://192.168.1.102:5118/'
// const rootUrl = 'http://localhost:7118/api/v1/'
// export const frontEndURL = 'http://localhost:5118/'

const rootUrl = 'https://server.o2bodmas.com:7118/api/v1/'
 export const frontEndURL = 'https://o2bodmas.com/'


const authURL = rootUrl + 'account';
const dashboardURL = rootUrl + 'dashboard';
const categoryURL = rootUrl + "category"
const testSeriesURL = rootUrl + "testSeries"
const mockTestURL = rootUrl + "mockTest"
const previousYearURL = rootUrl + "previousYear"
const lessionURL = rootUrl + "lesson"
const questionURL = rootUrl + "question"
const pagesURL = rootUrl + "pages"
const settingsURL = rootUrl + 'settings'
const faqsURL = rootUrl + 'faqs'
const slidersURL = rootUrl + 'sliders';
const userURL = rootUrl + 'user';
const examUserURL = rootUrl + 'examUser';
const examAttemptsURL = rootUrl + 'examAttempt';
const testAttemptURL = rootUrl + 'testAttempt';
const gkShortsURL = rootUrl + 'gkShorts';
const teachersURL = rootUrl + 'teachers'
const examinationURL = rootUrl + 'examination'
const transactionURL = rootUrl + 'transactions'

const examURL = rootUrl + 'mockTest';
const subscriptionURL = rootUrl + 'subscriptions';
const helpSupportURL = rootUrl + 'helpSupport';
const enquiryURL = rootUrl + 'enquiry';
const couponsURL = rootUrl + 'coupons';



const recoededSubjectURL = rootUrl + 'subject';
const recordedChapterURL = rootUrl + 'chapter';
const recordedLessonsURL = rootUrl + 'lecture';
const recordedQuestionsURL = rootUrl + 'lectureQuestion';

const liveSubjectURL = rootUrl + 'liveSubject'
const liveChapterURL = rootUrl + 'liveChapter'
const liveLessonURL = rootUrl + 'liveClass'
const liveQuestionURL = rootUrl + 'liveQuestion'


const enoteSubjectURL = rootUrl + 'enoteSubject'
const enoteChapterURL = rootUrl + 'enoteChapter'
const enoteLessonURL = rootUrl + 'enoteLecture'


const bodmasCategoryURL = rootUrl + 'bodmasCategory'
const bodmasTestSeriesURL = rootUrl + 'bodmasTestSeries'
const bodmasTestSLessonURL = rootUrl + 'bodmasTestLesson'
const boodmasTestQuestionsURL = rootUrl + 'bodmasTestQuestion'



async function login(loginData) {
  return await axios.post(authURL + '/admin/login', loginData);
}

async function getDashboard() {
  return await axios.get(dashboardURL, {
    headers: await authHeader()
  });
}

async function getCategory(limit, offset, status, keyword) {
  return await axios.get(categoryURL + '/admin?limit=' + limit + '&offset=' + offset + '&status=' + status + '&keyword=' + keyword, {
    headers: await authHeader(),
  });
}

async function addCategory(payload) {
  return await axios.post(categoryURL, payload, {
    headers: await authHeader(),
  });
}

async function updateCategory(id, payload) {
  return await axios.patch(categoryURL + '/' + id, payload, {
    headers: await authHeader(),
  });
}

async function statusUpdateCategory(id, status) {
  return await axios.put(categoryURL + '/' + id, { status }, {
    headers: await authHeader(),
  });
}
async function categoryImage(id, image) {
  return await axios.put(categoryURL + '/image/' + id, { image }, {
    headers: await authHeader('FormData'),
  });
}

// Bodmas Category
async function getBodmasCategory(limit = 10, offset = 0, status = '', keyword = '') {
  let url = bodmasCategoryURL + '/admin?limit=' + limit + '&offset=' + offset;
  if (status) url += '&status=' + status;
  if (keyword) url += '&keyword=' + keyword;
  return await axios.get(url, {
    headers: await authHeader(),
  });
}
async function addBodmasCategory(payload) {
  return await axios.post(bodmasCategoryURL, payload, {
    headers: await authHeader(),
  });
}
async function updateBodmasCategory(id, payload) {
  return await axios.patch(bodmasCategoryURL + '/' + id, payload, {
    headers: await authHeader(),
  });
}
async function statusUpdateBodmasCategory(id, status) {
  return await axios.put(bodmasCategoryURL + '/' + id, { status }, {
    headers: await authHeader(),
  });
}
async function bodmasCategoryImage(id, image) {
  return await axios.put(bodmasCategoryURL + '/image/' + id, { image }, {
    headers: await authHeader('FormData'),
  });
}
async function deleteBodmasCategory(id) {
  return await axios.delete(bodmasCategoryURL + '/' + id, {
    headers: await authHeader(),
  });
}


//Test Series
async function getTestSeries(limit, offset, status, keyword, categoryId) {
  return await axios.get(testSeriesURL + '/admin?limit=' + limit + '&offset=' + offset + '&status=' + status + '&keyword=' + keyword + '&categoryId=' + categoryId, {
    headers: await authHeader(),
  });
}
async function addTestSeries(data) {
  return await axios.post(testSeriesURL, data, {
    headers: await authHeader(),
  });
}
async function updateTestSeries(id, data) {
  return await axios.patch(testSeriesURL + '/' + id, data, {
    headers: await authHeader(),
  });
}
async function statusUpdateTestSeries(id, status) {
  return await axios.put(testSeriesURL + '/' + id, { status }, {
    headers: await authHeader(),
  });
}
async function testSeriesImage(id, image) {
  return await axios.put(testSeriesURL + '/image/' + id, { image }, {
    headers: await authHeader('FormData'),
  });
}

//MockTest
async function getmockTest(limit, offset, status, keyword, id) {
  return await axios.get(mockTestURL + '/admin?limit=' + limit + '&offset=' + offset + '&status=' + status + '&keyword=' + keyword + '&testId=' + id, {
    headers: await authHeader(),
  });
}
async function addmockTest(payload) {
  return await axios.post(mockTestURL, payload, {
    headers: await authHeader(),
  });
}
async function updatemockTest(id, data) {
  return await axios.patch(mockTestURL + '/' + id, data, {
    headers: await authHeader(),
  });
}
async function statusUpdatemockTest(id, status) {
  return await axios.put(mockTestURL + '/' + id, { status }, {
    headers: await authHeader(),
  });
}



//Previous Year
async function getpreviousYearQuestion(limit, offset, status, keyword, testId) {
  return await axios.get(previousYearURL + '/admin?limit=' + limit + '&offset=' + offset + '&status=' + status + '&keyword=' + keyword + '&testId=' + testId, {
    headers: await authHeader(),
  });
}

async function addPreviousYearQuestion(payload) {
  return await axios.post(previousYearURL, payload, {
    headers: await authHeader(),
  });
}

async function updatePreviousYearQuestion(id, data) {
  return await axios.patch(previousYearURL + '/' + id, data, {
    headers: await authHeader(),
  });
}

async function statusUpdatepreviousYearQuestion(id, status) {
  return await axios.put(previousYearURL + '/' + id, { status }, {
    headers: await authHeader(),
  });
}

//Lessons
async function getlesson(limit, offset, status, keyword, id) {
  return await axios.get(lessionURL + `/admin?limit=${limit}&offset=${offset}&status=${status}&keyword=${keyword}&mockTestId=${id}`, {
    headers: await authHeader(),
  });
}
async function addlesson(data) {
  return await axios.post(lessionURL, data, {
    headers: await authHeader(),
  });
}
async function updatelesson(id, data) {
  return await axios.patch(lessionURL + '/' + id, data, {
    headers: await authHeader(),
  });
}
async function statusUpdatelesson(id, status) {
  return await axios.put(lessionURL + '/' + id, { status }, {
    headers: await authHeader(),
  });
}


//Question
async function addQuestion(payload) {
  return await axios.post(questionURL, payload, {
    headers: await authHeader(),
  });
}
async function getQuestion(id) {
  return await axios.get(questionURL + '/admin/' + id, {
    headers: await authHeader(),
  });
}
async function getQuestionById(id) {
  return await axios.get(questionURL + '/byId/' + id, {
    headers: await authHeader(),
  });
}
async function updateQuestion(id, data) {
  return await axios.patch(questionURL + '/' + id, data, {
    headers: await authHeader(),
  });
}
async function DeleteQuestion(id,) {
  return await axios.delete(questionURL + '/' + id, {
    headers: await authHeader(),
  });
}

//Pages
async function getPage() {
  return await axios.get(pagesURL, {
    headers: await authHeader(),
  });
}
async function pagesData(id) {
  return await axios.get(pagesURL + '/' + id, {
    headers: await authHeader(),
  });
}
async function updatePage(id, description) {
  return await axios.patch(pagesURL + '/' + id, { description }, {
    headers: await authHeader(),
  });
}




// settings
async function getSettingsData() {
  return await axios.get(settingsURL, {
    headers: await authHeader(),
  });
}
async function updateSettingsData(data) {
  return await axios.patch(settingsURL, data, {
    headers: await authHeader(),
  });
}

//Faqs
async function getFaqs(limit, offset) {
  return await axios.get(faqsURL + '?limit=' + limit + '&offset=' + offset, {
  });
}
async function addFaqs(data) {
  return await axios.post(faqsURL, data, {
    headers: await authHeader(),
  });
}
async function updateFaqs(id, data) {
  return await axios.patch(faqsURL + '/' + id, data, {
    headers: await authHeader(),
  });
}
async function deleteFaqs(id,) {
  return await axios.delete(faqsURL + '/' + id, {
    headers: await authHeader(),
  });
}


//Sliders
async function getSliders(limit, offset) {
  return await axios.get(slidersURL + '?limit=' + limit + '&offset=' + offset, {
  });
}
async function addSlider(data) {
  return await axios.post(slidersURL, data, {
    headers: await authHeader(''),
  });
}
async function addImageToSlider(id, image) {
  return await axios.patch(slidersURL + '/' + id, { image }, {
    headers: await authHeader('FormData'),
  });
}
async function deleteSlider(id) {
  return await axios.delete(slidersURL + '/' + id, {
    headers: await authHeader(''),
  });
}
async function updateSlider(id, data, image) {
  const formData = new FormData();
  formData.append('type', data.type);
  formData.append('priority', data.priority !== undefined && data.priority !== null ? data.priority : 100);
  if (data.type === 'internal') {
    formData.append('internalLink', data.internalLink || '');
  } else if (data.type === 'external') {
    formData.append('externalLink', data.externalLink || '');
  }
  if (image) {
    formData.append('image', image);
  }
  return await axios.put(slidersURL + '/' + id, formData, {
    headers: await authHeader('FormData'),
  });
}

//User

async function getUserList(limit, offset, keyword, startDate = '', endDate = '') {
  return await axios.get(userURL + `/admin/all?limit=${limit}&offset=${offset}&keyword=${keyword}&startDate=${startDate}&endDate=${endDate}`, {
    headers: await authHeader()
  });
}
async function exportUsersCSV(keyword, startDate = '', endDate = '') {
  return await axios.get(userURL + `/admin/export-csv?keyword=${keyword}&startDate=${startDate}&endDate=${endDate}`, {
    headers: await authHeader()
  });
}
async function getUserDeviceChangeList(limit, offset) {
  return await axios.get(userURL + `/admin/deviceChange?limit=${limit}&offset=${offset}`, {
    headers: await authHeader()
  });
}

async function updateDeviceChangeStatus(id, status) {
  return await axios.post(userURL + `/admin/deviceChange/${id}`, { status }, {
    headers: await authHeader()
  });
}

async function getExamAttempts(limit, offset, type, search, examId = '') {
  return await axios.get(`${examAttemptsURL}?limit=${limit}&offset=${offset}&type=${type}&search=${search}&examId=${examId}`, {
    headers: await authHeader(),
  });
}

async function exportExamAttempts(type, search, examId = '') {
  return await axios.get(`${examAttemptsURL}/export?type=${type}&search=${search}&examId=${examId}`, {
    headers: await authHeader(),
    responseType: 'blob'
  });
}



// ExamUser
async function getExamUser(limit, offset, keyword) {
  return await axios.get(examUserURL + `/getAll?limit=${limit}&offset=${offset}&keyword=${keyword}`, {
  });
}
async function getExamList(id) {
  return await axios.get(testAttemptURL + `/examList?userId=${id}`, {
  });
}

async function getExam(id) {
  return await axios.get(examURL + '/temp/' + id,);
}
async function getQuestions(userId, lessonId) {
  return await axios.get(testAttemptURL + '/attempt/?userId=' + userId + '&lessonId=' + lessonId,);
}
async function getGkShorts(limit, offset) {
  return await axios.get(gkShortsURL + `/admin/?limit=${limit}&offset=${offset}`, {
    headers: await authHeader()
  });
}
async function addGkShorts(data) {
  return await axios.post(gkShortsURL, data, {
    headers: await authHeader()
  });
}
async function updateGkShorts(id, data) {
  return await axios.put(gkShortsURL + '/' + id, data, {
    headers: await authHeader()
  });
}
async function uploadGkShortVideo(id, video) {
  return await axios.patch(gkShortsURL + '/' + id, { video }, {
    headers: await authHeader('FormData')
  });
}
async function deleteGkShorts(id) {
  return await axios.delete(gkShortsURL + '/' + id, {
    headers: await authHeader('')
  });
}

//Teachers


async function getTeachers(limit, offset) {
  return await axios.get(teachersURL + `/all?limit=${limit}&offset=${offset}`, {
    headers: await authHeader()
  });
}
async function addTeachers(data) {
  return await axios.post(teachersURL, data, {
    headers: await authHeader()
  });
}
async function updateTeachers(id, data) {
  return await axios.patch(teachersURL + '/' + id, data, {
    headers: await authHeader()
  });
}
async function deleteTeacher(id) {
  return await axios.delete(teachersURL + '/' + id, {
    headers: await authHeader()
  });
}
async function getTeacherClassHours(teacherId, filter, startDate, endDate) {
  let url = teachersURL + `/${teacherId}/class-hours?filter=${filter}`;
  if (startDate) url += `&startDate=${startDate}`;
  if (endDate) url += `&endDate=${endDate}`;
  return await axios.get(url, { headers: await authHeader() });
}
async function getConsolidatedReport(filter, startDate, endDate) {
  let url = teachersURL + `/class-report/consolidated?filter=${filter}`;
  if (startDate) url += `&startDate=${startDate}`;
  if (endDate) url += `&endDate=${endDate}`;
  return await axios.get(url, { headers: await authHeader() });
}


//Transaction


async function getTransaction(limit, offset, keyword, fromDate, toDate, type) {
  return await axios.get(transactionURL + `/admin?limit=${limit}&offset=${offset}&keyword=${keyword}&fromDate=${fromDate}&toDate=${toDate}&type=${type}`, {
    headers: await authHeader()
  });
}
async function getTransactionDetails(id) {
  return await axios.get(transactionURL + `/details/${id}`, {
    headers: await authHeader()
  });
}

async function getsubscription() {
  return await axios.get(subscriptionURL, {
    headers: await authHeader(),
  })
}
async function addsubscription(data) {
  return await axios.post(subscriptionURL, data, {
    headers: await authHeader(),
  })
}
async function updatesubscription(id, data) {
  return await axios.patch(subscriptionURL + '/' + id, data, {
    headers: await authHeader(),
  })
}

async function gethelpSupport(limit, offset, status) {
  return await axios.get(helpSupportURL + `?limit=${limit}&offset=${offset}&status=${status}`, {
    headers: await authHeader(),
  })
}

async function updateSupportStatus(id, status) {
  return await axios.put(helpSupportURL + `/status/${id}`, { status }, {
    headers: await authHeader(),
  })
}

/********** Enquiry ************/
async function getEnquiries(limit, offset, keyword, targetExam) {
  return await axios.get(enquiryURL + `?limit=${limit}&offset=${offset}&keyword=${keyword || ''}&targetExam=${encodeURIComponent(targetExam || '')}`, {
    headers: await authHeader(),
  })
}

async function getTestSeriesNames() {
  return await axios.get(enquiryURL + '/test-series-names', {
    headers: await authHeader(),
  })
}

async function exportEnquiriesCSV(keyword = '', targetExam = '') {
  return await axios.get(enquiryURL + `/export-csv?keyword=${encodeURIComponent(keyword)}&targetExam=${encodeURIComponent(targetExam)}`, {
    headers: await authHeader(),
  })
}

/********** Coupons ************/
async function getCoupons() {
  return await axios.get(couponsURL, {
    headers: await authHeader(),
  })
}
async function addCoupons(data) {
  return await axios.post(couponsURL, data, {
    headers: await authHeader(),
  })
}
async function updateCoupons(id, data) {
  return await axios.patch(couponsURL + `/${id}`, data, {
    headers: await authHeader(),
  })
}
async function deleteCoupons(id, data) {
  return await axios.delete(couponsURL + `/${id}`, {
    headers: await authHeader(),
  })
}



/*********** RecordedSubject**********/
async function getrecordedClass(id) {
  return await axios.get(testSeriesURL + `/recorded/admin/${id}`);
}
async function addrecordedClass(data) {
  return await axios.post(testSeriesURL + '/subjects', data, {
    headers: await authHeader(),
  });
}
async function getrecordedSubject(limit, offset, status, keyword) {
  return await axios.get(recoededSubjectURL + `/admin?limit=${limit}&offset=${offset}&status=${status}&keyword=${keyword}`, {
    headers: await authHeader(),
  });
}
async function addrecordedSubject(data) {
  return await axios.post(recoededSubjectURL, data, {
    headers: await authHeader(),
  });
}
async function updaterecordedSubject(id, data) {
  return await axios.patch(recoededSubjectURL + '/' + id, data, {
    headers: await authHeader(),
  });
}
async function deleteRecordedSubject(id) {
  return await axios.delete(recoededSubjectURL + '/' + id, {
    headers: await authHeader(),
  });
}

/*********** Recorded Chapter**********/

async function getrecordedChapter(limit, offset, id) {
  return await axios.get(recordedChapterURL + '/' + id + '?limit=' + limit + '&offset=' + offset);
}
async function addrecordedChapter(data) {
  return await axios.post(recordedChapterURL, data, {
    headers: await authHeader(),
  });
}
async function updaterecordedChapter(id, data) {
  return await axios.patch(recordedChapterURL + '/' + id, data, {
    headers: await authHeader(),
  });
}
async function statusUpdaterecordedChapter(id) {
  return await axios.delete(recordedChapterURL + '/' + id, {
    headers: await authHeader(),
  });
}


/*********** Recorded Lessons r**********/

async function getrecordedLessons(limit, offset, id) {
  return await axios.get(recordedLessonsURL + '/admin/' + id + '?limit=' + limit + '&offset=' + offset);
}
async function addrecordedLessons(data) {
  return await axios.post(recordedLessonsURL, data, {
    headers: await authHeader()
  });
}
async function updaterecordedLessons(id, data) {
  return await axios.patch(recordedLessonsURL + '/' + id, data, {
    headers: await authHeader()
  });
}
async function recordedLessonsVideo(id, video) {
  console.log(id, video);

  return await axios.put(recordedLessonsURL + '/' + id, { video }, {
    headers: await authHeader('FormData')
  });
}
async function statusUpdaterecordedLessons(id) {
  return await axios.delete(recordedLessonsURL + '/' + id, {
    headers: await authHeader()
  });
}

/*********** Recorded Question ***********/

async function getrecordedQuestions(limit, offset, id) {
  return await axios.get(recordedQuestionsURL + '/' + id + '?limit=' + limit + '&offset=' + offset);
}
async function addrecordedQuestions(data) {
  return await axios.post(recordedQuestionsURL, data, {
    headers: await authHeader()
  });
}
async function updaterecordedQuestions(id, data) {
  return await axios.patch(recordedQuestionsURL + '/' + id, data, {
    headers: await authHeader()
  });
}
async function deleteRecordedQuestions(id,) {
  return await axios.delete(recordedQuestionsURL + '/' + id, {
    headers: await authHeader()
  });
}




/*********** LiveSubject**********/
async function getliveClass(id) {
  return await axios.get(testSeriesURL + `/live/admin/${id}`);
}
async function addliveClass(data) {
  return await axios.post(testSeriesURL + '/liveSubjects', data, {
    headers: await authHeader(),
  });
}

async function getliveSubject(limit, offset) {
  return await axios.get(liveSubjectURL + `/admin?limit=${limit}&offset=${offset}`, {
    headers: await authHeader(),
  });
}
async function addliveSubject(data) {
  return await axios.post(liveSubjectURL, data, {
    headers: await authHeader(),
  });
}
async function updateliveSubject(id, data) {
  return await axios.patch(liveSubjectURL + '/' + id, data, {
    headers: await authHeader()
  });
}
async function deleteLiveSubject(id,) {
  return await axios.delete(liveSubjectURL + '/' + id, {
    headers: await authHeader()
  });
}


async function getliveChapter(limit, offset, id) {
  return await axios.get(liveChapterURL + '/' + id + '?limit=' + limit + '&offset=' + offset);
}
async function addliveChapter(data) {
  return await axios.post(liveChapterURL, data, {
    headers: await authHeader(),
  });
}
async function updateliveChapter(id, data) {
  return await axios.patch(liveChapterURL + '/' + id, data, {
    headers: await authHeader()
  });
}
async function deleteLiveChapter(id,) {
  return await axios.delete(liveChapterURL + '/' + id, {
    headers: await authHeader()
  });
}

async function getliveLessons(limit, offset, id) {
  return await axios.get(liveLessonURL + '/' + id + '?limit=' + limit + '&offset=' + offset);
}
async function addliveLessons(data) {
  return await axios.post(liveLessonURL, data, {
    headers: await authHeader()
  })
}
async function updateliveLessons(id, data) {
  return await axios.patch(liveLessonURL + '/' + id, data, {
    headers: await authHeader()
  });
}
async function deleteLiveLessons(id) {
  return await axios.delete(liveLessonURL + '/' + id, {
    headers: await authHeader()
  });
}
async function deleteLiveClassRecording(id) {
  return await axios.delete(liveLessonURL + '/' + id + '/recording', {
    headers: await authHeader()
  });
}

async function getliveQuestions(limit, offset, id) {
  return await axios.get(liveQuestionURL + '/' + id + '?limit=' + limit + '&offset=' + offset);
}
async function addliveQuestions(data) {
  return await axios.post(liveQuestionURL, data, {
    headers: await authHeader()
  });
}
async function updateliveQuestions(id, data) {
  return await axios.patch(liveQuestionURL + '/' + id, data, {
    headers: await authHeader()
  });
}
async function deleteliveQuestions(id) {
  return await axios.delete(liveQuestionURL + '/' + id, {
    headers: await authHeader()
  });
}


/************ Enotes*************/
async function getenotes(id) {
  return await axios.get(testSeriesURL + '/enote/admin/' + id);
}
async function addenotes(data) {
  return await axios.post(testSeriesURL + '/enoteSubjects', data, {
    headers: await authHeader(),
  });
}
async function getenotesSubject(limit, offset) {
  return await axios.get(enoteSubjectURL + `/admin?limit=${limit}&offset=${offset}`);
}
async function addenotesSubject(data) {
  return await axios.post(enoteSubjectURL, data, {
    headers: await authHeader()
  });
}
async function updateenotesSubject(id, data) {
  return await axios.patch(enoteSubjectURL + '/' + id, data, {
    headers: await authHeader()
  });
}
async function deleteenotesSubject(id) {
  return await axios.delete(enoteSubjectURL + '/' + id, {
    headers: await authHeader()
  });
}


async function getenotesChapter(limit, offset, id) {
  return await axios.get(enoteChapterURL + '/' + id + '?limit=' + limit + '&offset=' + offset);
}
async function addenotesChapter(data) {
  return await axios.post(enoteChapterURL, data, {
    headers: await authHeader()
  });
}
async function updateenotesChapter(id, data) {
  return await axios.patch(enoteChapterURL + '/' + id, data, {
    headers: await authHeader()
  });
}
async function deletEnotesChapter(id) {
  return await axios.delete(enoteChapterURL + '/' + id, {
    headers: await authHeader()
  });
}
async function updateEnotesPdfChapter(id, file) {
  return await axios.put(enoteChapterURL + '/' + id, { file }, {
    headers: await authHeader('FormData')
  });
}




async function getenotesLessons(limit, offset, id) {
  return await axios.get(enoteLessonURL + '/byChapter/' + id + '?limit=' + limit + '&offset=' + offset);
}


/*******************Bodmas TestSeries *******************/

async function getBodmasTestSeries(limit, offset, status, keyword, categoryId = '') {
  let url = bodmasTestSeriesURL + `/admin?limit=${limit}&offset=${offset}&status=${status}&keyword=${keyword}`;
  if (categoryId) url += `&categoryId=${categoryId}`;
  return await axios.get(url);
}
async function addBodmasTestSeries(data) {
  return await axios.post(bodmasTestSeriesURL, data, {
    headers: await authHeader()
  });
}
async function updateBodmasTestSeries(id, data) {
  return await axios.patch(bodmasTestSeriesURL + '/' + id, data, {
    headers: await authHeader()
  });
}
async function statusUpdateBodmasTestSeries(id, status) {
  return await axios.put(bodmasTestSeriesURL + '/' + id, { status }, {
    headers: await authHeader()
  });
}

async function getbomasTestLesson(limit, offset, status, keyword, id) {
  return await axios.get(bodmasTestSLessonURL + `/admin?limit${limit}&offset=${offset}&status=${status}&keyword=${keyword}&bodmasTestId=${id}`);
}
async function addbomasTestLesson(data) {
  return await axios.post(bodmasTestSLessonURL, data, {
    headers: await authHeader()
  });
}
async function updatebomasTestLesson(id, data) {
  return await axios.patch(bodmasTestSLessonURL + '/' + id, data, {
    headers: await authHeader()
  });
}
async function statusUpdatebomasTestLesson(id, status) {
  return await axios.put(bodmasTestSLessonURL + '/' + id, { status }, {
    headers: await authHeader()
  });
}

async function getBodmasTestQuestions(id, limit, offset) {
  return await axios.get(boodmasTestQuestionsURL + '/admin/' + id + '?limit=' + limit + '&offset=' + offset);
}
async function addBodmasTestQuestions(data) {
  return await axios.post(boodmasTestQuestionsURL, data, {
    headers: await authHeader()
  });
}
async function updateBodmasTestQuestions(id, data) {
  return await axios.patch(boodmasTestQuestionsURL + '/' + id, data, {
    headers: await authHeader()
  });
}
async function deleteBodmasTestQuestions(id,) {
  return await axios.delete(boodmasTestQuestionsURL + '/' + id, {
    headers: await authHeader()
  });
}
async function getBodmasTestQuestionsById(id,) {
  return await axios.get(boodmasTestQuestionsURL + '/byId/' + id, {
    headers: await authHeader()
  });
}

async function getTeacherApplications(limit = 30, offset = 0, keyword = '', startDate = '', endDate = '') {
  return await axios.get(teachersURL + `/applications/all?limit=${limit}&offset=${offset}&keyword=${keyword}&startDate=${startDate}&endDate=${endDate}`, {
    headers: await authHeader()
  });
}

async function exportTeacherApplications(keyword = '', startDate = '', endDate = '') {
  return await axios.get(teachersURL + `/applications/export?keyword=${keyword}&startDate=${startDate}&endDate=${endDate}`, {
    headers: await authHeader(),
    responseType: 'blob'
  });
}

async function getTeacherApplicationById(id) {
  return await axios.get(teachersURL + `/applications/${id}`, {
    headers: await authHeader()
  });
}

async function updateTeacherApplicationStatus(id, status) {
  return await axios.patch(teachersURL + `/applications/${id}/status`, { status }, {
    headers: await authHeader()
  });
}

async function getExamination(limit = 30, offset = 0, status = '', keyword = '', testSeriesId = '') {
  return await axios.get(examinationURL + `?limit=${limit}&offset=${offset}&status=${status}&keyword=${keyword}&testSeriesId=${testSeriesId}`, {
    headers: await authHeader()
  });
}

async function addExamination(data) {
  return await axios.post(examinationURL, data, {
    headers: await authHeader()
  });
}

async function updateExamination(id, data) {
  return await axios.patch(examinationURL + `/${id}`, data, {
    headers: await authHeader()
  });
}

async function statusUpdateExamination(id, status) {
  return await axios.patch(examinationURL + `/${id}/status`, { status }, {
    headers: await authHeader()
  });
}

async function deleteExamination(id) {
  return await axios.delete(examinationURL + `/${id}`, {
    headers: await authHeader()
  });
}

async function updateExaminationImage(id, file) {
  const formData = new FormData();
  formData.append('image', file);
  return await axios.put(examinationURL + `/image/${id}`, formData, {
    headers: await authHeader()
  });
}











export const service = {

  getDashboard,
  login,
  getCategory, addCategory, updateCategory, statusUpdateCategory, categoryImage,
  getTestSeries, addTestSeries, statusUpdateTestSeries, testSeriesImage, updateTestSeries,
  getmockTest, addmockTest, updatemockTest, statusUpdatemockTest,
  getpreviousYearQuestion, addPreviousYearQuestion, updatePreviousYearQuestion, statusUpdatepreviousYearQuestion,
  getlesson, addlesson, updatelesson, statusUpdatelesson,
  addQuestion, getQuestion, getQuestionById, updateQuestion, DeleteQuestion,
  getPage, pagesData, updatePage,
  getSettingsData, updateSettingsData,
  getFaqs, addFaqs, updateFaqs, deleteFaqs,
  getSliders, addSlider, addImageToSlider, deleteSlider, updateSlider,
  getUserList, exportUsersCSV, getUserDeviceChangeList, updateDeviceChangeStatus,
  getExamAttempts, exportExamAttempts,

  getExamUser, getExamList,
  getExam, getQuestions,

  getGkShorts, addGkShorts, updateGkShorts, uploadGkShortVideo, deleteGkShorts,

  getTeachers, addTeachers, updateTeachers, deleteTeacher, getTeacherClassHours, getConsolidatedReport,


  getTransaction, getTransactionDetails,

  getsubscription, addsubscription, updatesubscription,

  gethelpSupport, updateSupportStatus,
  getEnquiries, getTestSeriesNames, exportEnquiriesCSV,

  getCoupons, addCoupons, updateCoupons, deleteCoupons,

  //Recorded
  getrecordedClass, addrecordedClass,
  getrecordedSubject, addrecordedSubject, updaterecordedSubject, deleteRecordedSubject,

  getrecordedChapter, addrecordedChapter, updaterecordedChapter, statusUpdaterecordedChapter,

  getrecordedLessons, addrecordedLessons, updaterecordedLessons, recordedLessonsVideo, statusUpdaterecordedLessons,

  getrecordedQuestions, addrecordedQuestions, updaterecordedQuestions, deleteRecordedQuestions,

  //Live class

  getliveClass, addliveClass,
  getliveSubject, addliveSubject, updateliveSubject, deleteLiveSubject,

  getliveChapter, addliveChapter, updateliveChapter, deleteLiveChapter,

  getliveLessons, addliveLessons, updateliveLessons, deleteLiveLessons, deleteLiveClassRecording,

  getliveQuestions, addliveQuestions, updateliveQuestions, deleteliveQuestions,


  //Enote

  getenotes, addenotes,
  getenotesSubject, addenotesSubject, updateenotesSubject, deleteenotesSubject,

  getenotesChapter, addenotesChapter, updateenotesChapter, deletEnotesChapter, updateEnotesPdfChapter,

  getenotesLessons,

  //BodmasTESTSERIES

  getBodmasCategory, addBodmasCategory, updateBodmasCategory, statusUpdateBodmasCategory, bodmasCategoryImage, deleteBodmasCategory,

  getBodmasTestSeries, addBodmasTestSeries, updateBodmasTestSeries, statusUpdateBodmasTestSeries,

  getbomasTestLesson, addbomasTestLesson, updatebomasTestLesson, statusUpdatebomasTestLesson,

  getBodmasTestQuestions, addBodmasTestQuestions, updateBodmasTestQuestions, deleteBodmasTestQuestions, getBodmasTestQuestionsById,

  // Teacher Applications
  getTeacherApplications, exportTeacherApplications, getTeacherApplicationById, updateTeacherApplicationStatus,

  // Examination
  getExamination, addExamination, updateExamination, statusUpdateExamination, deleteExamination, updateExaminationImage,
};






